// FCT TYPES:
// 4: KAS
// 7: AeroWIN
// 8: E-Heizstab
// 9: BioWIN & co.
// 10: LogWIN
// 14: UML
// 15: WVF
// 16: BPLM
// 20: ZSP
// 25: PuroWIN
// 26: Hybridmanager

import { mapGetters } from 'vuex';

export default {
    data() {
        return {
            queue: [],
            // parameterLayersConst: {},
        };
    },
    computed: {
        ...mapGetters(['parameterLayersConst']),
    },
    created() {
        // do nothing for now
    },
    methods: {
        parameterLayerGet(layerName, fctType, deviceClass) {
            let device =
                this.parameterLayersConst[deviceClass + '/' + fctType] ||
                this.parameterLayersConst['default/' + fctType];

            if (!device || !device[layerName]) return [];

            return JSON.parse(JSON.stringify(device[layerName]));
        },
    },
};
